@if (isCurrentViewType('table')) {
    <skl-table-view
        [dataSource]="dataSource$"
        [columns]="columns$"
        [displayHeaders] = "displayHeaders"
        [customTemplates]="customTemplates"
        [noDataRowTemplate]="noDataRowTemplate"
        [options]="options">
    </skl-table-view>
} @else if (isCurrentViewType('table-virtual')) {
    <skl-table-view-virtual
        [dataSource]="dataSource$"
        [columns]="columns$"
        [displayHeaders] = "displayHeaders"
        [customTemplates]="customTemplates"
        [noDataRowTemplate]="noDataRowTemplate"
        [options]="options">
    </skl-table-view-virtual>
} @else if (isCurrentViewType('compact')) {
    <skl-compact-view
        [template]="compactViewTemplate"
        [dataSource]="dataSource$">
    </skl-compact-view>
}